export const QUICK_START_STORE = 'quickStart/store';

export const QUICK_START_DESTROY = 'quickStart/destroy';

export default {
  QUICK_START_STORE,
  QUICK_START_DESTROY,
};
